import { render } from "./Gymnastics.vue?vue&type=template&id=7df74c72&scoped=true"
import script from "./Gymnastics.vue?vue&type=script&lang=js"
export * from "./Gymnastics.vue?vue&type=script&lang=js"

import "./Gymnastics.vue?vue&type=style&index=0&id=7df74c72&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df74c72"]])

export default __exports__